import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';
import { Form } from '@tencent/wb-ext-form';
import { Controller, Loader, ActionPointInfo } from '@tencent/workbench';
import { FORM_CONFIGS } from './config';
import { IChartFontFamilyFeature } from './font-family-interface';
import type { IDynamicLoader } from '@tencent/workbench';

@Controller({
    adapters: [SLIDE_ADAPTER],
    formItems: FORM_CONFIGS,
})
export class ChartFontFamilyController {
    constructor(@Loader(IChartFontFamilyFeature) private loader: IDynamicLoader<IChartFontFamilyFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(ChartFormItemKey.GLOBAL_FONT_FAMILY, 'content')
    public renderFontFamily(@ActionPointInfo() info) {
        return this.feature.renderFontFamily(info);
    }
}

